import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderImage from './CommonHeaderImage';
import CommonHeaderRightImage from './CommonHeaderRightImage';

const OnlyImagetHeader = () => {
	return (
		<Header>
			<HeaderLeft>
				<div />
			</HeaderLeft>
			<CommonHeaderRightImage afterChildren={<CommonHeaderImage />} />
		</Header>
	);
};

export default OnlyImagetHeader;
